import React from "react";
import { 
    Table, Input, Row, Col, Pagination, Button, Spin, notification, Form, 
    FormInstance, Modal, Popconfirm, Select, TreeSelect, Badge, Breadcrumb, 
    Dropdown, Menu, Space, InputNumber, DatePicker, Empty, ConfigProvider,
 } from "antd";
 import dayjs from 'dayjs';
import { connect } from "react-redux";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { RootStoreModel } from "@redux/reducers";
import { BasicStateForListModel } from "../models";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { gaEvent } from "@src/withTracker";
import { 
    getOptionsLog, getOptionsType, getPlatformLog, 
    exportDeviceLog, exportPlatformLog 
} from "@axios/api.account";
import { commandRetry } from "@axios/api.device";

import { Translation } from "react-i18next";
import i18n from "@src/locales";
import zh_CN from "antd/es/locale/zh_CN";
import en_US from "antd/es/locale/en_US";

interface stateModel extends BasicStateForListModel {
    formatDate: string,
    startDate: string,
    endDate: string,
    platform: string
    operationType: string,
    deviceInfo: string,
    isDisabled: boolean,
    options: any,
    deltaTime: number,
    logType: string,
}

interface propsModel extends RouteComponentProps<any, any, any> {}

const { Column } = Table;
const { Option } = Select;
const mapStatetoProps = (state: RootStoreModel) => ({})

class LogListPage extends React.Component<propsModel, stateModel> {
    constructor(props: propsModel) {
        super(props);
        this.state = {
            loading: false,
            columns: [],
            data: [],
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            formatDate: "YYYY/MM/DD",
            startDate: "",
            endDate: "",
            platform: "",
            operationType: "",
            deviceInfo: "",
            isDisabled: true,
            options: {},
            deltaTime: 86400000*7,
            logType: "platformLog",
        }
        this.getList();
    }

    getList(pageIndex=this.state.pageIndex, pageSize=this.state.pageSize, type=this.state.logType) {
        this.setState({loading: true});
        if (type === "platformLog") {
            var paramsData = {
                TimeStart: this.state.startDate ? this.state.startDate : dayjs(new Date().getTime()-this.state.deltaTime).format(this.state.formatDate),
                TimeEnd: this.state.endDate ? this.state.endDate : dayjs(new Date().getTime()+86400000*1).format(this.state.formatDate),
                PageIndex: pageIndex, 
                PageSize: pageSize
            };
            getPlatformLog(paramsData).then(
                res => {
                    this.setState({
                        data: res.dataList,
                        pageIndex: res.pageIndex,
                        pageSize: res.pageSize,
                        totalCount: res.totalCount,
                    });
                    if (res.dataList.length === 0) {
                        notification.warning({message: <Translation>{t => {return t("未查询到信息")}}</Translation>});
                    }
                },
                () => {
                    notification.error({message: <Translation>{t => {return t("查询失败")}}</Translation>});
                }
            ).finally(
                () => {
                    this.setState({loading: false});
                }
            )
        } else {
            var params = {
                startDate: this.state.startDate ? this.state.startDate : dayjs(new Date().getTime()-this.state.deltaTime).format(this.state.formatDate),
                endDate: this.state.endDate ? this.state.endDate : dayjs(new Date().getTime()+86400000*1).format(this.state.formatDate),
                platform: this.state.platform,
                operationType: this.state.operationType,
                search: this.state.deviceInfo,
                pageIndex: pageIndex, 
                pageSize: pageSize
            };
            getOptionsLog(params).then(
                res => {
                    this.setState({
                        data: res.dataList,
                        pageIndex: res.pageIndex,
                        pageSize: res.pageSize,
                        totalCount: res.totalCount,
                    });
                    if (res.dataList.length === 0) {
                        notification.warning({message: <Translation>{t => {return t("未查询到信息")}}</Translation>});
                    }
                },
                () => {
                    notification.error({message: <Translation>{t => {return t("查询失败")}}</Translation>});
                }
            ).finally(
                () => {
                    this.setState({loading: false});
                }
            )
        }
    }

    getOptions(param: any) {
        if (param && param !== "0") {
            getOptionsType(param).then(
                res => {                    
                    if (Object.keys(res).length > 0) {
                        this.setState({options: res, isDisabled: false});
                    } else {
                        this.setState({options: {}, isDisabled: true});
                    }
                },
                () => {
                    this.setState({options: {}, isDisabled: true});
                    notification.error({message: <Translation>{t => {return t("获取操作类型失败")}}</Translation>});
                }
            ).finally(
                () => {
                    this.setState({loading: false, operationType: ""});
                }
            )
        } else {
            this.setState({ isDisabled: true, options: {}, operationType: ""});
        }
    }

    onDateChange(dates: any) {
        if (dates && dates.length > 0) {
            const [startDate, endDate] = dates;
            this.setState({
                startDate: startDate.format(this.state.formatDate), 
                endDate: endDate.format(this.state.formatDate)
            });
        } else {
            this.setState({
                startDate: "", 
                endDate: ""
            });
        }
    }

    onSearch() {
        this.getList(1);
    }

    retryClick(id: string) {
        commandRetry(id).then(() => {
            notification.success({ message: <Translation>{t => {return t("重试成功")}}</Translation> });
        })
    }

    handleClick = (e: any) => {
        this.setState({ logType: e.key, data: [] });
        this.getList(1, 20, e.key);
    }

    refreshTable = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            this.setState({ loading: false })
        }, 2000);
    }

    exportLog = () => {
        switch (this.state.logType) {
            case "platformLog":
                exportPlatformLog({
                    TimeStart: this.state.startDate || dayjs(new Date().getTime()-this.state.deltaTime).format(this.state.formatDate),
                    TimeEnd: this.state.endDate || dayjs(new Date().getTime()+86400000*1).format(this.state.formatDate),
                }).then(
                    (res) => {
                        let blob = new Blob([res], {type: 'application/vnd.ms-excel'});
                        let downloadElement = document.createElement('a');
                        let href = window.URL.createObjectURL(blob);
                        downloadElement.href = href;
                        downloadElement.download = `platformoperations_${dayjs(new Date()).format('YYYYMMDDHHmmss')}.xls`;
                        document.body.appendChild(downloadElement);
                        downloadElement.click();
                        document.body.removeChild(downloadElement);
                        window.URL.revokeObjectURL(href);
                        notification.success({message: <Translation>{t => {return t("导出成功")}}</Translation>})
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("导出失败")}}</Translation>})
                    }
                )
                break;

            case "deviceLog":
                exportDeviceLog({
                    startDate: this.state.startDate || dayjs(new Date().getTime()-this.state.deltaTime).format(this.state.formatDate),
                    endDate: this.state.endDate || dayjs(new Date().getTime()+86400000*1).format(this.state.formatDate),
                    platform: this.state.platform,
                    operationType: this.state.operationType,
                    search: this.state.deviceInfo
                }).then(
                    (res) => {
                        let blob = new Blob([res], {type: 'application/vnd.ms-excel'});
                        let downloadElement = document.createElement('a');
                        let href = window.URL.createObjectURL(blob);
                        downloadElement.href = href;
                        downloadElement.download = `deviceoperations_${dayjs(new Date()).format('YYYYMMDDHHmmss')}.xls`;
                        document.body.appendChild(downloadElement);
                        downloadElement.click();
                        document.body.removeChild(downloadElement);
                        window.URL.revokeObjectURL(href);
                        notification.success({message: <Translation>{t => {return t("导出成功")}}</Translation>})
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("导出失败")}}</Translation>})
                    }
                )
                break;
        
            default:
                break;
        }
    }

    render() {
        const {
            loading,
            columns,
            data,
            pageIndex,
            pageSize,
            totalCount,
            formatDate,
            startDate,
            endDate,
            isDisabled,
            options,
            operationType,
            deltaTime,
            logType,
        } = this.state;        
        
        return (
            <Translation>{t => {
                return (
                    <>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("日志")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 19px 0"}}>
                                    <Space>
                                        <img src="/images/rizhi.svg" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("日志")}</span>
                                    </Space>
                                </Row>
                                {/* <Row>
                                    <Menu onClick={this.handleClick} mode="horizontal" selectedKeys={[logType]} style={{borderBottom: 0, marginLeft: -20, width: "100%"}}>
                                        <Menu.Item key="platformLog" disabled={loading}>{t("Platform Log")}</Menu.Item>
                                        <Menu.Item key="deviceLog" disabled={loading}>{t("Device Log")}</Menu.Item>
                                    </Menu>
                                </Row> */}
                            </h5>
                            <Row style={{ width: "100%" }}>
                                <div className="borderBox">
                                    <Row className="mb-3">
                                        <Col span={5} style={{display: "flex", alignItems: "center"}}>
                                            <label style={{whiteSpace: "nowrap", marginRight: "5px"}}>{t("时间")}: </label>
                                            <DatePicker.RangePicker 
                                                style={{width: "100%"}}
                                                format={formatDate}
                                                defaultValue={[dayjs(startDate ? startDate : dayjs(new Date().getTime()-deltaTime).format(formatDate), formatDate), dayjs(endDate ? endDate : dayjs(new Date().getTime()+86400000*1).format(formatDate), formatDate)]}
                                                onChange={(dates) => { 
                                                    gaEvent("dateChange", "onChange", "updateDate");
                                                    this.onDateChange(dates);
                                                }}
                                            />
                                        </Col>
                                        {logType === "deviceLog" && (
                                            <>
                                                <Col span={4} offset={1} style={{display: "flex", alignItems: "center"}}>
                                                    <label style={{whiteSpace: "nowrap", marginRight: "5px"}}>{t("平台")}: </label>
                                                    <Select 
                                                        style={{width: "100%"}}
                                                        allowClear
                                                        placeholder={t("全部")}
                                                        onChange={(value: string) => {
                                                            this.setState({platform: value && value !== "0" ? value : ""});
                                                            this.getOptions(value);
                                                        }}
                                                    >
                                                        <Option value="0">{t("全部")}</Option>
                                                        <Option value="IOS">iOS</Option>
                                                        <Option value="Android">Android</Option>
                                                        <Option value="macOS">macOS</Option>
                                                    </Select>
                                                </Col>
                                                <Col span={4} offset={1} style={{display: "flex", alignItems: "center"}}>
                                                    <label style={{whiteSpace: "nowrap", marginRight: "5px"}}>{t("操作")}: </label>
                                                    <Select 
                                                        style={{width: "100%"}}
                                                        allowClear
                                                        onChange={(value: string) => {this.setState({operationType: value ? value : ""})}}
                                                        disabled={isDisabled}
                                                        value={operationType}
                                                    >
                                                        {Object.keys(options).map((key) => (
                                                            <Option key={key} value={key[0].toUpperCase()+key.substring(1)}>{options[key]}</Option>
                                                        ))}
                                                    </Select>
                                                </Col>
                                                <Col span={5} offset={1} style={{display: "flex", alignItems: "center"}}>
                                                    <label style={{whiteSpace: "nowrap", marginRight: "5px"}}>{t("设备")}: </label>
                                                    <Input placeholder={t("输入设备名称/持有人/部门")} onChange={(e) => {this.setState({deviceInfo: e.target.value})}}></Input>
                                                </Col>
                                            </>
                                        )}
                                        <Col offset={1}>
                                            <Button 
                                                type="primary" 
                                                onClick={() => {
                                                    gaEvent("log", "onClick", "onSearch");
                                                    this.onSearch();
                                                }}
                                            >{t("查询")}</Button>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="borderBox" style={{overflow: "hidden"}}>
                                    <Row justify="end">
                                        <Col>
                                            <Button type="text" onClick={this.refreshTable}><ReloadOutlined /></Button>
                                            <Button type="text" onClick={this.exportLog}><DownloadOutlined /></Button>
                                        </Col>
                                    </Row>
                                    {logType === "platformLog" && (
                                        <Table 
                                            size="middle" 
                                            loading={loading}
                                            // scroll={{x: 1500}}
                                            dataSource={data} 
                                            style={{width: "100%"}} 
                                            pagination={false}
                                            rowKey={item => item.id}
                                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                        >
                                            <Column title={t("模块")} key="module" dataIndex="module"></Column>
                                            <Column title={t("内容")} key="content" dataIndex="content"></Column>
                                            <Column title={t("结果")} key="result" dataIndex="result"></Column>
                                            <Column title={t("操作人")} key="operator" dataIndex="operator"></Column>
                                            <Column title={t("操作时间")} key="operationTime" dataIndex="operationTime"></Column>
                                        </Table>
                                    )}
                                    {logType === "deviceLog" && (
                                        <Table 
                                            size="middle" 
                                            loading={loading}
                                            scroll={{x: 2200}}
                                            dataSource={data} 
                                            style={{width: "100%"}} 
                                            pagination={false}
                                            rowKey={item => item.id}
                                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                        >
                                            <Column title={t("模块")} key="moduleName" dataIndex="moduleName"></Column>
                                            <Column title={t("操作")} key="operationType" dataIndex="operationType"></Column>
                                            <Column title={t("设备信息(设备名称、持有人、部门)")} key="deviceInfo" dataIndex="id" render={(id, item: any) => {
                                                const deviceName = item.deviceName ? item.deviceName : "未配置";
                                                const userName = item.userName ? item.userName : "未配置";
                                                const organizationName = item.organizationName ? item.organizationName : "未配置";
                                                return deviceName + "、" + userName + "、" + organizationName;
                                            }}></Column>
                                            <Column title={t("内容")} key="content" dataIndex="content"></Column>
                                            <Column title={t("结果")} key="result" dataIndex="result"></Column>
                                            <Column title={t("失败原因")} key="errorMessage" dataIndex="errorMessage"></Column>
                                            <Column title={t("操作人")} key="account" dataIndex="account"></Column>
                                            <Column title={t("操作时间")} key="operationTime" dataIndex="operationTime"></Column>
                                            <Column key="id" dataIndex="id" render={(id, item: any) => {
                                                return (
                                                    <>
                                                        {!item.isSuccess && item.result === "失败" && (
                                                            <Button style={{color: "#007ACC"}} onClick={() => { 
                                                                gaEvent("errorLogRetry", "onClick", "retryClick");
                                                                this.retryClick(id); 
                                                            }}>{t("重试")}</Button>
                                                        )}
                                                    </>
                                                )
                                            }}></Column>
                                        </Table>
                                    )}
                                    <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
                                        <Pagination
                                            style={{textAlign: "right", marginTop: "20px"}}
                                            pageSize={pageSize}
                                            current={pageIndex}
                                            total={totalCount}
                                            showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                            onChange={(page, pageSize) => this.getList(page, pageSize)}
                                            onShowSizeChange={(current, size) => this.getList(current, size)}
                                        ></Pagination>
                                    </ConfigProvider>
                                </div>
                            </Row>
                        </div>
                    </>
                )
            }}</Translation>
        )
    }
}

export default connect(mapStatetoProps, {})(LogListPage)
